import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { GdprConsent } from '../consent.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-consent-popup',
    templateUrl: './consent-popup.component.html',
    styleUrls: ['./consent-popup.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        MatIcon,
        MatDialogContent,
        MatSlideToggle,
        FormsModule,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
    ],
})

export class ConsentPopupComponent implements OnInit {
  analytics: boolean;
  essential = true; // always true;
  constructor(@Inject(MAT_DIALOG_DATA) public data: GdprConsent,
              public dialog: MatDialogRef<ConsentPopupComponent>) {
  }

  ngOnInit() {
    this.analytics = !!this.data?.consents?.analytics;
  }

  /**
   * Determines whether the save button will be enabled. If a GDPR cookie does not exist, it has to
   * be enabled.
   */
  isChange() {
    return !this.data || this.analytics !== this.data.consents.analytics;
  }

  /**
   * Generates popup return value
   */
  onSave() {
    const result: GdprConsent = {
      consents: {
        analytics: this.analytics,
        essential: this.essential,
      },
    };

    return result;
  }


}
